import PropTypes from 'prop-types'
import { Fragment, useMemo } from 'react'
import classNames from 'classnames'
import { getLandingUrlState } from 'features/creative/creativeUtil'
import { AssetCategories, Assets } from 'features/Codes'
import { AssetClassNames } from 'features/creative/preview/PreviewParts'
import BasicPreview from 'features/creative/preview/BasicPreview'
import SiteUrlPropTypes from '../../channel/SiteUrlPropTypes'

const AssetPreview = ({ creative, isMobileView, siteUrl }) => {
  const basic = {
    title: creative.title,
    description: creative.description,
    licenseNumber: creative.licenseNumber,
    landingUrl: creative.landingUrl
      ? getLandingUrlState(creative.landingUrl)
      : null,
  }
  const assets = useMemo(
    () =>
      isMobileView
        ? creative.assets
        : creative.assets.filter(
            asset => asset.type.name !== Assets.PHONE_NUMBER.name
          ),
    [creative.assets, isMobileView]
  )

  return (
    <>
      <div className="view_tit">
        <strong className="tit_view">확장소재</strong>
        <span className="txt_view">개별소재</span>
      </div>
      <div
        className={classNames('view_detail', {
          view_mo: isMobileView,
          view_pc: !isMobileView,
        })}>
        {assets.map(({ type, data }) => (
          <Fragment key={type.name}>
            <div className="material_expand">
              <span className="mix_type">{`${
                AssetCategories[type.category].title
              } > ${AssetClassNames[type.name].title}`}</span>
              <BasicPreview
                key={type.name}
                basic={basic}
                type={type.name}
                data={data}
                siteUrl={siteUrl}
                isMobileView={isMobileView}
              />
            </div>
          </Fragment>
        ))}
      </div>
    </>
  )
}

export default AssetPreview

AssetPreview.propTypes = {
  creative: PropTypes.object.isRequired,
  siteUrl: SiteUrlPropTypes.isRequired,
  isMobileView: PropTypes.bool.isRequired,
}
